import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 py-12 text-gray-800">
      <h1 className="text-3xl font-bold text-teal-800 mb-6">Privacy Policy</h1>

      <p className="mb-4">
        This Privacy Policy outlines how we collect, use, and protect your personal data when you use the IBAN Analyzer API service.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-2">1. Information We Collect</h2>
      <p className="mb-4">
        We collect personal data you provide directly during signup, including your name, email address, and billing information. We also collect usage data for analytics and security.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-2">2. How We Use Your Information</h2>
      <p className="mb-4">
        We use your data to provide and maintain the service, process payments, improve performance, and communicate with you. We do not sell your personal data to third parties.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-2">3. Cookies and Analytics</h2>
      <p className="mb-4">
        We use cookies and analytics tools to understand user behavior, diagnose issues, and improve the experience. You may disable cookies in your browser settings.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-2">4. Data Sharing</h2>
      <p className="mb-4">
        We may share data with trusted service providers (e.g., payment processors) only when necessary for service delivery and only under strict confidentiality agreements.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-2">5. Data Retention</h2>
      <p className="mb-4">
        We retain your data only as long as necessary to provide our services and comply with legal obligations. You may request deletion of your account and associated data.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-2">6. Your Rights</h2>
      <p className="mb-4">
        You have the right to access, correct, or delete your personal data. You may also object to certain processing and request data portability.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-2">7. Contact</h2>
      <p className="mb-4">
        For privacy-related questions or data requests, contact us at:{' '}
        <a href="mailto:support@iban-analyzer.com" className="text-teal-600 underline">
          support@iban-analyzer.com
        </a>
      </p>

      <p className="text-sm text-gray-500 mt-8">
        Last updated: {new Date().toLocaleDateString()}
      </p>
    </div>
  );
};

export default PrivacyPolicy;
